import React from "react";
import { IconSize, IconProps } from "../theme";

const Home: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 14.4436V25.9998C28 26.5303 27.7893 27.039 27.4142 27.414C27.0391 27.7891 26.5304 27.9998 26 27.9998H21C20.4696 27.9998 19.9609 27.7891 19.5858 27.414C19.2107 27.039 19 26.5303 19 25.9998V20.9998C19 20.7346 18.8946 20.4803 18.7071 20.2927C18.5196 20.1052 18.2652 19.9998 18 19.9998H14C13.7348 19.9998 13.4804 20.1052 13.2929 20.2927C13.1054 20.4803 13 20.7346 13 20.9998V25.9998C13 26.5303 12.7893 27.039 12.4142 27.414C12.0391 27.7891 11.5304 27.9998 11 27.9998H6C5.46957 27.9998 4.96086 27.7891 4.58579 27.414C4.21071 27.039 4 26.5303 4 25.9998V14.4436C3.99996 14.1668 4.05737 13.893 4.16861 13.6395C4.27985 13.3861 4.4425 13.1584 4.64625 12.9711L14.6462 3.53608L14.66 3.52233C15.0282 3.18749 15.508 3.00195 16.0056 3.00195C16.5033 3.00195 16.9831 3.18749 17.3512 3.52233C17.3555 3.52722 17.3601 3.53181 17.365 3.53608L27.365 12.9711C27.5667 13.1594 27.7273 13.3875 27.8365 13.6409C27.9458 13.8943 28.0015 14.1676 28 14.4436Z"
        fill="#071443"
      />
    </svg>
  );
};

export default Home;
